import {
  CourseSubtitleState,
  CourseSubtitleActionTypes,
  COURSE_SUBTITLES_REQUEST,
  COURSE_SUBTITLES_SUCCESS,
  COURSE_SUBTITLES_FAILURE,
} from "./types";

/**
 * Initial state for the course subtitle reducer.
 */
const initialState: CourseSubtitleState = {
  courseSubtitles: [],
  isLoading: false,
  courseSubtitlesLoaded: false,
  error: false,
};

/**
 * Reducer handling course subtitle state changes.
 *
 * Manages course subtitle data, loading state, and error state
 * based on dispatched actions.
 *
 * @param state - Current course subtitle state.
 * @param action - Action dispatched to update the state.
 * @returns Updated state after applying the action.
 */
export const courseSubtitleReducer = (
  state = initialState,
  action: CourseSubtitleActionTypes
): CourseSubtitleState => {
  switch (action.type) {
    case COURSE_SUBTITLES_REQUEST:
      return { ...state, isLoading: true, error: false };
    case COURSE_SUBTITLES_SUCCESS:
      return {
        ...state,
        courseSubtitles: action.data,
        courseSubtitlesLoaded: true,
        isLoading: false,
        error: false,
      };
    case COURSE_SUBTITLES_FAILURE:
      return { ...state, isLoading: false, error: true };
    default:
      return state;
  }
};
